var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InvitationCapture',{attrs:{"step":_vm.step},on:{"clicked":_vm.updateStep}})}
var staticRenderFns = []

export { render, staticRenderFns }